import { MapPin, Mail, Clock } from "lucide-react";
import { ADDRESS, ADDRESS_REF, EMAIL_PLACEHOLDER, WA_MAIN, WA_ALT, WA_MAIN_LABEL, WA_ALT_LABEL, waLink, INSTAGRAM } from "./constants";
import { WhatsAppIcon, InstagramIcon } from "./Icons";
import { Reveal, Eyebrow } from "./Reveal";
import { ContactForm } from "./ContactForm";

const MAP = `https://maps.google.com/maps?q=${encodeURIComponent("Av. Brigadeiro Hilário Gurjão, 1830, Jorge Teixeira, Manaus - AM")}&z=16&output=embed`;

const Info = ({ icon: Icon, title, children, testid }) => (
  <div className="flex gap-4 border-b border-white/10 py-5" data-testid={testid}>
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#FACC15] text-[#0c0a09]"><Icon className="h-4 w-4" /></span>
    <div>
      <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-stone-400">{title}</p>
      <div className="mt-1 text-sm text-stone-100 sm:text-base">{children}</div>
    </div>
  </div>
);

export const Contact = () => (
  <section id="contato" className="relative bg-[#0f0b08] py-24 sm:py-32" data-testid="contact-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Contato</Eyebrow>
        <h2 className="font-display mt-5 text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">Fale com a <span className="text-[#FACC15]">Destak</span></h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <div className="border border-white/10 bg-[#15100c] p-6 sm:p-10"><ContactForm /></div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <Info icon={MapPin} title="Endereço" testid="contact-address">
            {ADDRESS}<br /><span className="text-stone-400">{ADDRESS_REF}</span>
          </Info>
          <Info icon={WhatsAppIcon} title="WhatsApp" testid="contact-whatsapp">
            <a href={waLink("Olá, Destak!", WA_MAIN)} target="_blank" rel="noopener noreferrer" className="hover:text-[#FACC15]" data-testid="contact-wa-main">{WA_MAIN_LABEL}</a>
            <span className="mx-2 text-stone-500">|</span>
            <a href={waLink("Olá, Destak!", WA_ALT)} target="_blank" rel="noopener noreferrer" className="hover:text-[#FACC15]" data-testid="contact-wa-alt">{WA_ALT_LABEL}</a>
          </Info>
          <Info icon={Mail} title="E-mail" testid="contact-email"><span className="text-stone-400">{EMAIL_PLACEHOLDER}</span></Info>
          <Info icon={Clock} title="Horário" testid="contact-hours">
            Seg. a Sex.: 08:00 às 17:00 (sem fechar para almoço)<br />Feriados: 08:00 às 12:00
          </Info>
          <Info icon={InstagramIcon} title="Instagram" testid="contact-instagram">
            <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="hover:text-[#FACC15]">@destak.am</a>
          </Info>
          <div className="mt-6 aspect-[16/10] overflow-hidden border border-white/10">
            <iframe title="Mapa Destak" src={MAP} loading="lazy" className="h-full w-full grayscale contrast-125" data-testid="contact-map" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
